<pu-simple-input
  class="select"
  [formControl]="control()"
  [iconTemplate]="arrowTmpl"
  #dropdownRef="puDropdownTrigger"
  [puDropdownTriggerFor]="dropdown"
  [placeholder]="placeholder()"
  [label]="label()"
  [isDisabled]="control().disabled"
  [hint]="hint()"
  [isHintVisible]="true"
  [required]="required()"
  [style.height.px]="height()"
  [showValidationMessage]="false"
  [offReadonlyStyle]="true"
  [offsetY]="height() + 4"
  [autoOverlayPosition]="true"
  [isReadonly]="true">
</pu-simple-input>

<ng-template #arrowTmpl>
  <div class="icons-tmpl">
    @if (clearable() && control().value) {
      <pu-icon
        class="clear-icon"
        iconName="pu-close-spaced"
        size="20"
        (click)="clear($event)" />
    }
    <pu-icon
      class="arrow-icon"
      [class.active]="dropdownRef.isDropdownOpened$ | async"
      iconName="pu-chevron-right"
      size="20" />
  </div>
</ng-template>

@if (selectedValue) {
  <div class="selected-item" [class.clearable]="clearable()">
    <ng-container
      *ngTemplateOutlet="
        itemTpl() || defaultItemTpl;
        context: { $implicit: selectedValue }
      " />
  </div>
}

<pu-dropdown #dropdown>
  <div class="dropdown">
    <div class="search">
      <input
        class="search-control"
        type="text"
        [placeholder]="'searchSelect.placeholder' | translate"
        [formControl]="searchControl"
        (click)="$event.stopPropagation()" />

      <pu-icon class="search-icon" iconName="search" size="16" />
    </div>

    @if (filteredItems().length) {
      <div class="select-items" [class.select-items-tmpl]="itemTpl()">
        @for (item of filteredItems(); track item[valueField()]) {
          <div
            class="select-item"
            [class.selected]="isSelected(item)"
            (click)="toggleItem(item, $event)">
            @if (multi()) {
              <pu-icon
                class="checkbox"
                size="16"
                [iconName]="
                  isSelected(item) ? 'pu-ms-checkbox-active' : 'pu-ms-checkbox'
                " />
            }
            <ng-container
              *ngTemplateOutlet="
                itemTpl() || defaultItemTpl;
                context: { $implicit: item }
              " />
          </div>
        }
      </div>
    }
  </div>
</pu-dropdown>

<ng-template #defaultItemTpl let-item>
  <div class="select-item-default">
    @if (item.icon) {
      <pu-icon [iconName]="item.icon" size="20" />
    }

    {{ item[nameField()] || item | translate }}
  </div>
</ng-template>
